var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-new flex items-center justify-center border-green-600 dark:border-white text-green-600 dark:text-white text-sm font-medium cursor-pointer",on:{"click":_vm.handleClick}},[(_vm.icon)?_c('fluent-icon',{staticClass:"mr-2",attrs:{"size":18,"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }